import React from "react";
import {
    Box,
    Button,
    Divider,
    Drawer,
    IconButton,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { formatCurrency } from "../../utils/currency";

const CartDrawer = ({
    open,
    onClose,
    cartItems,
    onRemove,
    onQuantityChange,
    subtotal,
    onCheckout,
    checkoutLabel = "Proceed to checkout",
    paymentCurrency = "EUR"
}) => {
    const formatMoney = (value) => formatCurrency(value, paymentCurrency);

    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Box sx={{ width: { xs: 340, sm: 420 }, p: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
                    Cart
                </Typography>
                <Stack spacing={2}>
                    {cartItems.map((item) => (
                        <Box key={item.productId} sx={{ border: "1px solid #eee", borderRadius: 2, p: 1.5 }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1 }}>
                                <Box>
                                    <Typography sx={{ fontWeight: 600 }}>{item.name}</Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {formatMoney(item.finalPrice)} per item
                                    </Typography>
                                </Box>
                                <IconButton onClick={() => onRemove(item.productId)}>
                                    <DeleteIcon />
                                </IconButton>
                            </Box>

                            <Box sx={{ mt: 1, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
                                <TextField
                                    type="number"
                                    label="Qty"
                                    size="small"
                                    value={item.quantity}
                                    onChange={(event) => onQuantityChange(item.productId, Number(event.target.value))}
                                    inputProps={{ min: 1, max: item.stockQuantity }}
                                    sx={{ width: 90 }}
                                />
                                <Typography sx={{ fontWeight: 700 }}>
                                    {formatMoney(item.finalPrice * item.quantity)}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Stack>

                {!cartItems.length ? (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                        Cart is empty.
                    </Typography>
                ) : null}

                <Divider sx={{ my: 2 }} />
                <Stack spacing={0.5}>
                    <Typography variant="body2">Subtotal: {formatMoney(subtotal)}</Typography>
                </Stack>

                <Button
                    fullWidth
                    variant="contained"
                    sx={{ mt: 2 }}
                    disabled={!cartItems.length}
                    onClick={onCheckout}
                >
                    {checkoutLabel}
                </Button>
            </Box>
        </Drawer>
    );
};

export default CartDrawer;
